const context = 'promotor';
const abrev = 'pro';

export default [
    {
        // COCKPIT
        path: '/pro/cockpit',
        name: 'pro-cockpit',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/cockpit/CockpitPromotor.vue'),
    },

    {
        path: '/pro/meus-promotores',
        name: 'meuspromotores',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/meus-promotores/MeusPromotoresRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'meuspromotores-list',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import('@/components/promotor/meus-promotores/MeusPromotoresList.vue'),
                children: [
                    {
                        path: 'view/:id',
                        name: 'meuspromotores-view',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/meus-promotores/MeusPromotoresView.vue'),
                    },
                ],
            },
        ],
    },

    {
        path: '/pro/cadastros/cliente',
        name: 'clientes',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/cliente/ClienteRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'clientes-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/cliente/ClienteList.vue'),
                children: [
                    {
                        path: 'importar',
                        name: 'clientes-importacao',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/content/import/Clientes.vue'),
                    },
                    {
                        path: 'new',
                        name: 'clientes-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/cliente/ClienteManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'clientes-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/cliente/ClienteManage.vue'),
                    },
                ],
            },
        ],
    },

    {
        path: '/pro/cadastros/regiao',
        name: 'regioes',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/regiao/RegiaoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'pro-regiao-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/regiao/RegiaoList.vue'),
            },
            {
                path: 'new',
                name: 'pro-regiao-new',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/regiao/RegiaoManage.vue'),
            },
            {
                path: 'edit/:id',
                name: 'pro-regiao-edit',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/regiao/RegiaoManage.vue'),
            },
        ],
    },
    {
        path: '/pro/cadastros/rede',
        name: 'redes',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/rede/RedeRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'pro-rede-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/rede/RedeList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'pro-rede-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/rede/RedeManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'pro-rede-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/rede/RedeManage.vue'),
                    },
                ],
            },
        ],
    },
    {
        path: '/pro/cadastros/bandeira',
        name: 'bandeiras',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/bandeira/BandeiraRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'pro-bandeira-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/bandeira/BandeiraList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'pro-bandeira-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/bandeira/BandeiraManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'pro-bandeira-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/bandeira/BandeiraManage.vue'),
                    },
                ],
            },
        ],
    },
    {
        path: '/pro/cadastros/lps',
        name: 'lpss',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/lps/LpsRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'lps-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/lps/LpsList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'lps-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/lps/LpsManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'lps-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/lps/LpsManage.vue'),
                    },
                ],
            },
        ],
    },
    {
        path: '/pro/cadastros/lps/importar',
        name: 'importacao-lps',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/content/import/LPS.vue'),
    },
    {
        path: '/pro/cadastros/rota',
        name: 'rotas',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/rota/RotaRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'rota-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/rota/RotaList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'rota-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/rota/RotaManage.vue'),
                    },
                    {
                        path: ':id',
                        name: 'rota-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/rota/RotaManage.vue'),
                    },
                ],
            },
        ],
    },
    // formulario antigo
    {
        path: '/pro/cadastros/consulta',
        name: 'formulario-consulta',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/formulario/old/Formulario.vue'),
        children: [
            {
                path: 'list',
                name: 'formulario-consulta-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/formulario/old/FormularioList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'formulario-consulta-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/formulario/old/FormularioManage.vue'),
                    },
                    {
                        path: 'new/:id',
                        name: 'formulario-consulta-duplicate-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/formulario/old/FormularioManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'formulario-consulta-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/formulario/old/FormularioManage.vue'),
                    },
                ],
            },
        ],
    },
    {
        path: '/pro/cadastros/formulario',
        name: 'formulario',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/formulario/FormularioRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'formulario-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/formulario/FormularioList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'formulario-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/formulario/FormularioManage.vue'),
                    },
                    {
                        path: 'new/:id',
                        name: 'formulario-duplicate-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/formulario/FormularioManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'formulario-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/formulario/FormularioManage.vue'),
                    },
                ],
            },
        ],
    },

    {
        path: '/pro/cadastros/tipo-servico',
        name: 'tipos-servicos',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/tipo-servico/TipoServicoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'tipo-servico-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/tipo-servico/TipoServicoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'tipo-servico-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/tipo-servico/TipoServicoManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'tipo-servico-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/tipo-servico/TipoServicoManage.vue'),
                    },
                ],
            },
        ],
    },

    {
        path: '/pro/cadastros/evento',
        name: 'events',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/evento/EventoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'evento-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/evento/EventoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'evento-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/evento/EventoManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'evento-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/evento/EventoManage.vue'),
                    },
                ],
            },
        ],
    },

    {
        path: '/pro/cadastros/motivo-foto',
        name: 'photoreasons',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/motivo-foto/MotivoFotoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'motivo-foto-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/motivo-foto/MotivoFotoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'motivo-foto-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/motivo-foto/MotivoFotoManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'motivo-foto-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/motivo-foto/MotivoFotoManage.vue'),
                    },
                ],
            },
        ],
    },

    {
        path: '/pro/cadastros/motivo-visita',
        name: 'visitreasons',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/motivo-visita/MotivoVisitaRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'motivo-visita-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/motivo-visita/MotivoVisitaList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'motivo-visita-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/motivo-visita/MotivoVisitaManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'motivo-visita-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/motivo-visita/MotivoVisitaManage.vue'),
                    },
                ],
            },
        ],
    },

    {
        path: '/pro/cadastros/produto',
        name: 'produtos',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/produto/ProdutoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'pro-produto-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/produto/ProdutoList.vue'),
                children: [
                    {
                        path: 'import',
                        name: 'pro-produto-import',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/produto/ProdutoImport.vue'),
                    },
                    {
                        path: 'new',
                        name: 'pro-produto-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/produto/ProdutoManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'pro-produto-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/produto/ProdutoManage.vue'),
                    },
                ],
            },
        ],
    },

    {
        path: '/pro/cadastros/marca',
        name: 'marcas',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/marca/MarcaRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'marca-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/marca/MarcaList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'marca-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/marca/MarcaManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'marca-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/marca/MarcaManage.vue'),
                    },
                ],
            },
        ],
    },

    {
        path: '/pro/cadastros/grupo-produto',
        name: 'grupos',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/grupo-produto/GrupoProdutoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'pro-produto-grupo-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/grupo-produto/GrupoProdutoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'pro-produto-grupo-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/grupo-produto/GrupoProdutoManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'pro-produto-grupo-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/grupo-produto/GrupoProdutoManage.vue'),
                    },
                ],
            },
        ],
    },

    {
        path: '/pro/cadastros/subgrupo-produto',
        name: 'subgrupos',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/subgrupo-produto/SubGrupoProdutoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'pro-produto-sub-grupo-list',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import('@/components/promotor/subgrupo-produto/SubGrupoProdutoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'new-subgrupo',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import(
                                '@/components/promotor/subgrupo-produto/SubGrupoProdutoManage.vue'
                            ),
                    },
                    {
                        path: 'edit/:id',
                        name: 'edit-subgrupo',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import(
                                '@/components/promotor/subgrupo-produto/SubGrupoProdutoManage.vue'
                            ),
                    },
                ],
            },
        ],
    },
    {
        path: '/pro/cadastros/linha',
        name: 'linhas',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/linha-produto/LinhaProdutoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'pro-produto-linha-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/linha-produto/LinhaProdutoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'new-linha',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/linha-produto/LinhaProdutoManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'edit-linha',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import('@/components/promotor/linha-produto/LinhaProdutoManage.vue'),
                    },
                ],
            },
        ],
    },
    {
        path: '/pro/cadastros/turno',
        name: 'promotor-turnos',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/turno/TurnoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'promotor-turno-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/turno/TurnoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'promotor-turno-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/turno/TurnoManage.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'promotor-turno-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/turno/TurnoManage.vue'),
                    },
                ],
            },
        ],
    },
    {
        path: '/pro/empresas/feriado',
        name: 'promotor-feriados',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/feriado/FeriadoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'promotor-feriados-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/feriado/FeriadoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'promotor-feriados-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/feriado/FeriadoManager.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'promotor-feriados-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/feriado/FeriadoManager.vue'),
                    },
                ],
            },
        ],
    },
    {
        // RELATÓRIOS
        path: '/pro/relatorios/atendimento-ppt',
        name: 'report-rota-ppt',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import('@/components/promotor/relatorio/atendimentoPpt/AtendimentoPPT.vue'),
    },
    {
        path: '/pro/relatorios/atendimento-contrato',
        name: 'report-rota',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import(
                '@/components/promotor/relatorio/atendimentoContrato/AtendimentoContratoRoute.vue'
            ),
        children: [
            {
                path: 'list',
                name: 'promotor-contrato-list',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import(
                        '@/components/promotor/relatorio/atendimentoContrato/AtendimentoContratoList.vue'
                    ),
                children: [
                    {
                        path: 'atendimento-list/:idcontrato/:data',
                        name: 'promotor-atendimento-contrato-list',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import(
                                '@/components/promotor/relatorio/atendimentoContrato/AtendimentoByContratoList.vue'
                            ),
                        children: [
                            {
                                path: 'view-contrato/:idatendimento',
                                name: 'promotor-atendimento-contrato-view',
                                meta: { contexto: context, abrev: abrev },
                                component: () =>
                                    import(
                                        '@/components/promotor/relatorio/atendimento/AtendimentoView.vue'
                                    ),
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        path: '/pro/relatorios/atendimento-lps',
        name: 'pro-report-atendimentolps',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import('@/components/promotor/relatorio/atendimentoLps/AtendimentoLpsRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'promotor-lps-list',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import('@/components/promotor/relatorio/atendimentoLps/AtendimentoLpsList.vue'),
                children: [
                    {
                        path: 'atendimento-list/:idlps/:data',
                        name: 'promotor-atendimento-lps-list',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import(
                                '@/components/promotor/relatorio/atendimentoLps/AtendimentoByLpsList.vue'
                            ),
                        children: [
                            {
                                path: 'view-contrato/:idatendimento',
                                name: 'promotor-atendimento-lps-view',
                                meta: { contexto: context, abrev: abrev },
                                component: () =>
                                    import(
                                        '@/components/promotor/relatorio/atendimento/AtendimentoView.vue'
                                    ),
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        path: '/pro/relatorios/atendimento',
        name: 'pro-report-atendimento',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/relatorio/atendimento/AtendimentoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'promotor-atendimento-list',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import('@/components/promotor/relatorio/atendimento/AtendimentoList.vue'),
                children: [
                    {
                        path: 'view/:idatendimento',
                        name: 'promotor-atendimento-view',
                        meta: { contexto: context, abrev: abrev },
                        component: () =>
                            import(
                                '@/components/promotor/relatorio/atendimento/AtendimentoView.vue'
                            ),
                    },
                ],
            },
        ],
    },
    {
        path: '/pro/relatorios/atendimento-form/:idatendimento/:idformulario',
        name: 'promotor-atendimento-form-view',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import('@/components/promotor/relatorio/atendimento/AtendimentoFormularioView.vue'),
    },

    {
        path: '/pro/relatorios/formulario-respondido',
        name: 'formulario-respondido',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import('@/components/promotor/relatorio/formulario/RespostaFormularioList.vue'),
        children: [
            {
                path: 'view/:idFormulario',
                name: 'formulario-respondido-view',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import('@/components/promotor/relatorio/formulario/CockpitRespostaFormulario.vue'),
            },
        ]
    },

    // formulario respondido antigo
    {
        path: '/pro/relatorios/formulario-respondido-consulta',
        name: 'formulario-respondido-consulta',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import('@/components/promotor/relatorio/formulario/old/FormulariosResultados.vue'),
    },
    {
        path: '/pro/relatorios/formulario-respondido-consulta/:id',
        name: 'formulario-respondido-consulta-edit',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import('@/components/promotor/relatorio/formulario/old/FormularioResultado.vue'),
    },
    {
        path: '/pro/relatorio-analitico/ruptura',
        name: 'relatorio-ruptura',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import(
                '@/components/promotor/relatorio-analitico/relatorio-ruptura/RelatorioRupturaRoute.vue'
            ),
        children: [
            {
                path: 'list',
                name: 'relatorio-ruptura-list',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import(
                        '@/components/promotor/relatorio-analitico/relatorio-ruptura/RelatorioRupturaListRoute.vue'
                    ),
            },
        ],
    },
    {
        path: '/pro/relatorio-analitico/check-in-out',
        name: 'relatorio-pro-check-in-out',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import(
                '@/components/promotor/relatorio-analitico/relatorio-check-in-out/RelatorioCheckInOutRoute.vue'
            ),
        children: [
            {
                path: 'list',
                name: 'relatorio-pro-check-in-out-list',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import(
                        '@/components/promotor/relatorio-analitico/relatorio-check-in-out/RelatorioCheckInOutListRoute.vue'
                    ),
            },
        ],
    },
    {
        path: '/pro/relatorio-analitico/relatorio-faturamento',
        name: 'relatorio-faturamento',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import(
                '@/components/promotor/relatorio-analitico/relatorio-faturamento/RelatorioFaturamentoRoute.vue'
            
            ),
        children: [
            {
                path: 'list',
                name: 'relatorio-faturamento-list',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import(
                        '@/components/promotor/relatorio-analitico/relatorio-faturamento/RelatorioFaturamentoListRoute.vue'
                    ),
            },
        ],
    },
    {
        path: '/pro/relatorio-analitico/relatorio-lps-nao-visita',
        name: 'relatorio-lps-nao-visita',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import(
                '@/components/promotor/relatorio-analitico/relatorio-lps-nao-visita/RelatorioLpsNaoVisitaRoute.vue'
            
            ),
        children: [
            {
                path: 'list',
                name: 'relatorio-lps-nao-visita-list',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import(
                        '@/components/promotor/relatorio-analitico/relatorio-lps-nao-visita/RelatorioLpsNaoVisitaListRoute.vue'
                    ),
            },
        ],
    },
    {
        path: '/pro/relatorio-analitico/vencimento',
        name: 'relatorio-pro-vencimento',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import(
                '@/components/promotor/relatorio-analitico/relatorio-vencimento/RelatorioVencimentoRoute.vue'
            ),
        children: [
            {
                path: 'list',
                name: 'relatorio-pro-vencimento-list',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import(
                        '@/components/promotor/relatorio-analitico/relatorio-vencimento/RelatorioVencimentoListRoute.vue'
                    ),
            },
        ],
    },
    {
        path: '/pro/relatorio-analitico/relatorio-justificativa-nao-atendimento',
        name: 'relatorio-justificativa-nao-atendimento',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import(
                '@/components/promotor/relatorio-analitico/relatorio-justificativa-nao-atendimento/RelatorioJustificativaNaoAtendimentoRoute.vue'
            ),
        children: [
            {
                path: 'list',
                name: 'relatorio-justificativa-nao-atendimento-list',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import(
                        '@/components/promotor/relatorio-analitico/relatorio-justificativa-nao-atendimento/RelatorioJustificativaNaoAtendimentoListRoute.vue'
                    ),
            },
        ],
    },
    {
        path: '/pro/relatorio-analitico/pesquisa',
        name: 'relatorio-pro-pesquisa',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import(
                '@/components/promotor/relatorio-analitico/relatorio-pesquisa/RelatorioPesquisaRoute.vue'
            ),
        children: [
            {
                path: 'list',
                name: 'relatorio-pro-pesquisa-list',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import(
                        '@/components/promotor/relatorio-analitico/relatorio-pesquisa/RelatorioPesquisaListRoute.vue'
                    ),
            },
        ],
    },
    {
        path: '/pro/relatorio-analitico/formulario-resposta',
        name: 'relatorio-pro-formulario-resposta',
        meta: { contexto: context, abrev: abrev },
        component: () =>
            import(
                '@/components/promotor/relatorio-analitico/relatorio-formulario-resposta/RelatorioFormularioRespostaRoute.vue'
            ),
        children: [
            {
                path: 'list',
                name: 'relatorio-pro-formulario-resposta-list',
                meta: { contexto: context, abrev: abrev },
                component: () =>
                    import(
                        '@/components/promotor/relatorio-analitico/relatorio-formulario-resposta/RelatorioFormularioRespostaListRoute.vue'
                    ),
            },
        ],
    },
    {
        path: '/pro/empresa',
        name: 'pro-empresa',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/empresa/EmpresaRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'pro-empresa-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/empresa/EmpresaList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'pro-empresa-new',
                        meta: { contexto: context, abrev: abrev },
                        redirect: { name: 'pro-empresa-dados-cadastrais-new' },
                        component: () => import('@/components/vendas/empresa/EmpresaManage.vue'),
                        children: [
                            {
                                path: 'dados-cadastrais',
                                name: 'pro-empresa-dados-cadastrais-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () =>
                                    import('@/components/vendas/empresa/AbaDadosCadastrais.vue'),
                            },
                        ],
                    },
                    {
                        path: 'edit/:id',
                        name: 'pro-empresa-edit',
                        meta: { contexto: context, abrev: abrev },
                        redirect: { name: 'pro-empresa-dados-cadastrais-edit' },
                        component: () => import('@/components/vendas/empresa/EmpresaManage.vue'),
                        children: [
                            {
                                path: 'dados-cadastrais',
                                name: 'pro-empresa-dados-cadastrais-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () =>
                                    import('@/components/vendas/empresa/AbaDadosCadastrais.vue'),
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        // portal do cliente
        path: '/pro/portal-do-cliente',
        name: 'pro-portal-do-cliente',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/portal-do-cliente/PortalDoClienteRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'pro-portal-do-cliente-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/portal-do-cliente/PortalDoClienteUserList.vue'),
            },
        ]
    },
];
